export default __webpack_public_path__ + "static/media/16thepe.96429343.jpg";